// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { MASTER_URL, MASTER_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { RoleIndex } = lazily(() => import('pages/back-office/master/role'))

const roleRoutes: IRoute[] = [
  {
    path: MASTER_URL.ROLE,
    component: RoleIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: MASTER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'masterRole.role',
        accessCodes: [9911],
      },
    },
  },
]

export { roleRoutes }
